module.exports = __webpack_public_path__ + "img/login_page.7e9bfcec.png";